const LOCAL_API = 'http://127.0.0.1:8000/api';
/** Относительный URL — тот же протокол, что у страницы (HTTPS на проде без mixed content). */
const PROD_API = '/api';

const isDevelopment = process.env.NODE_ENV === 'development';

/** В dev всегда локальный backend; в production — REACT_APP_API_URL или /api. */
export const API_BASE_URL = isDevelopment
  ? process.env.REACT_APP_API_URL || LOCAL_API
  : process.env.REACT_APP_API_URL || PROD_API;

export const IS_LOCAL_API =
  API_BASE_URL.includes('127.0.0.1') || API_BASE_URL.includes('localhost');

if (isDevelopment && typeof console !== 'undefined') {
  console.info('[API] dev mode →', API_BASE_URL);
}
